import React from 'react'
import Slides from '../slides/Slides'
import Prestadores from './Prestadores';
import Contratos from './Contratos';
import Prevencion from './Prevencion';
import Siniestros from './Siniestros';
import Footer from '../footer/Footer';

const Descargas = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides={"descargas"} />
         <div className="animated fadeIn">
            <div className="container section">
               <Prestadores/>
               <Contratos/>
               <Prevencion/>
               <Siniestros/>
            </div>
         </div>
      </>
   );
}

export default Descargas